import React from 'react';

import { HTMLDataTrackerProps } from '@/app/types';

export type DataTrackerSectionProps = Required<
  Pick<HTMLDataTrackerProps, 'data-tracker-section'>
>;

export type SectionProps = React.ComponentProps<'section'> &
  DataTrackerSectionProps;

const Section = (props: SectionProps) => {
  return <section {...props} />;
};

export default Section;
